module.exports = __webpack_public_path__ + "media/images/custom-ads/amazon.svg";